



























import Vue from 'vue'

import LeftTree from './components/LeftTree.vue'
import HistoryData from './components/HistoryData.vue'
import dayjs from 'dayjs';

import { WorkStationWorkingConditionParamSettingServiceProxy} from '@/service-proxies/app-v2/workStation.service-proxies'
import { ProcessParametersServiceProxy} from '@/service-proxies/app-v2/mdc.service-proxies'
const ppsp = new ProcessParametersServiceProxy()
const wscpsp=new WorkStationWorkingConditionParamSettingServiceProxy()
export default Vue.extend({
  components: {
    LeftTree,
    HistoryData
  },
  data() {
    return {
      loading:false,
      tabsdData:[],
      operationData:[],
      historyData: undefined,
      processData:[],
      chooseIndex: 0,
      filter: 1,
      dataList: [] ,
    }
  },

  computed: {
    top30(){
      if(this.processData.length<=30){
        return this.processData.map(c=>c.paramDesc);
      }const names =[];
        for(var i=0;i<30;i++){
          names.push(this.processData[i].paramDesc);
        }
        return names;
    }
  },
  mounted() {
  },
  created() {
  },
  destroyed() {
  },
  methods: {
    onLeftTreeSearch(value,name){
      
      
      this.workStationName=name
      this.searchValue = value
      this.searchValue['workStationName'] = name
      this.selectTime = value.date
      this.workStationId = value.workStationId
      this.onGetWork()
        .then(res=>{
          return ppsp.getTimeSlot(value)
        })
        .then(res =>{
          console.log('getTimeSlot:', res);
          if(res){
            this.tabsdData = res
            this.getTableTime = this.tabsdData[this.chooseIndex]
            this.getTableList(this.top30)
            
          }
        });
    },
    
    onLeftTreeOutPut(){

    },
    onChangeTabs(data){
      const { value, propertyList } =data;
      console.log('onChangeTabs:', data);
      this.tabsdData.forEach((res,index) =>{
        if (index === value){
          this.chooseIndex = index
          this.getTableTime = res
          this.getTableList(propertyList)
          
        }
      })
    },
    onShowTypeChange(){},
    onGetWork(){
      return wscpsp.getWorkingConditionParams(this.workStationId).then(res=>{
        this.processData=[]
        this.processData=res
        return res;
      })
    },
    getTableList(propertyNameList) {
      this.loading = true
      const time = this.getSelectTime(this.getTableTime)
      this.historyData = {}
      
      const data = {
        beginTime: dayjs(time[0]).format('YYYY-MM-DD HH:mm:ss'),
        endTime: dayjs(time[1]).format('YYYY-MM-DD HH:mm:ss'),
        workStationId: this.workStationId,
        filter: this.filter,
        propertyNameList
      }
      ppsp.findProcessParameters(data as any).then(res =>{
        this.historyData = res
      }).finally(() =>{
        this.loading = false
      })
    },
    getSelectTime(value){
      let time = []
      time = value.split('~')
      return time
    }

  },
  watch:{

  }
})
